import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import { validateToken } from "./jwt";
import zoneLocalStorageId from "utils/zone";
const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchData = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    limit,
    page_no,
    zone_id,
    ...filter,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(EndPoints.RESULT_ENTRY_REPORT.LIST, {
    params,
  });
};

export const fetchFranchisePatientReportData = (
  page_no,
  filter,
  searchValueParams,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    limit,
    page_no,
    zone_id: zoneLocalStorageId(),
    ...filter,
  };

  if (searchValueParams) {
    const today = new Date();
    const to_date = today.toISOString().split("T")[0];

    const pastDate = new Date(today);
    pastDate.setMonth(pastDate.getMonth() - 6);
    const from_date = pastDate.toISOString().split("T")[0];

    params = {
      ...params,
      multi_search_var: searchValueParams,
      from_date,
      to_date,
    };
  }

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(
    EndPoints.RESULT_ENTRY_REPORT.FRANCHISE_PATIENT_REPORT_LIST,
    {
      params,
    }
  );
};

// export const fetchReportPDf = (payload) => {
//   if (payload?.token) {
//     if (validateToken(payload?.token)) {
//       return axiosInstance.get(`${EndPoints.RESULT_ENTRY_REPORT.PDF_LIST}/?investigation_id=${payload?.investigation_id}&appointment_id=${payload?.appointment_id}`,
//         {
//           headers: {
//             "Authorization": `Bearer ${payload?.token}`,
//           }
//         }
//       );
//     }
//     return;
//   }
//   else {
//     return axiosInstance.get(`${EndPoints.RESULT_ENTRY_REPORT.PDF_LIST}/?investigation_id=${payload?.investigation_id}&appointment_id=${payload?.appointment_id}`
//     );
//   }
// };

export const fetchReportPDf = (payload) => {
  const { appointment_id, investigation_id, token } = payload;

  if (token) {
    if (validateToken(token)) {
      const investigationParams = investigation_id
        .map((id) => `investigation_ids=${id}`)
        .join("&");

      return axiosInstance.get(
        `${EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF_MULTIPLES_INVESTIGATION}/?${investigationParams}&appointment_id=${appointment_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
    return;
  } else {
    const investigationParams = investigation_id
      .map((id) => `investigation_ids=${id}`)
      .join("&");

    return axiosInstance.get(
      `${EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF_MULTIPLES_INVESTIGATION}/?${investigationParams}&appointment_id=${appointment_id}`
    );
  }
};

export const fetchQRCodeKey = async (key) => {
  if (key) {
    const res = await axiosInstance.get(
      `${EndPoints.RESULT_ENTRY_REPORT.QRCODE_PDF}/${key?.token}`,
      {
        responseType: "blob",
        transformResponse: [(data) => data],
      }
    );
    return res;
  }
};

export const fetchReportPDfDownload = (payload) => {
  return axiosInstance.put(
    `${EndPoints.RESULT_ENTRY_REPORT.PDF_DOWNLOAD_LIST}/?appointment_id=${payload?.appointment_id}`,
    {},
    {
      responseType: "blob",
    }
  );
};

export const fetchDownloadInvestigationDocument = ({
  appointment_id,
  investigation_id,
}) => {
  return axiosInstance.get(
    `${EndPoints.RESULT_ENTRY_REPORT.INVESTIGATION_DOCUMENT_DOWNLOAD}/${appointment_id}/${investigation_id}`
  );
};

export const fetchObservationResultEntryData = (payload) => {
  const { appointment_id, investigation_id } = payload;
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    appointment_id,
    investigation_id,
    // zone_id,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  if (appointment_id && investigation_id) {
    return axiosInstance.get(EndPoints.RESULT_ENTRY_REPORT.OBSERVATION_LIST, {
      params,
      timeout: 30000,
    });
  }
  return;
};

export const fetchInvestigationObservationDropDown = (payload) => {
  const { investigation_id, req_help_data } = payload;
  let params = {
    investigation_id,
    req_help_data,
  };

  if (investigation_id) {
    return axiosInstance.get(
      EndPoints.RESULT_ENTRY_REPORT.INVESTIGATION_OBSERVATION_DD_LIST,
      {
        params,
      }
    );
  }
  return;
};

export const fetchOnlyOrganismData = () => {
  let params = {
    only_organism: true,
  };

  return axiosInstance.get(EndPoints.RESULT_ENTRY_REPORT.ONLY_ORGANISM_LIST, {
    params,
  });
};

export const fetchViewObservationResultEntryData = (payload) => {
  const { registartion_id } = payload;
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    registartion_id,
    zone_id,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(
    EndPoints.RESULT_ENTRY_REPORT.VIEW_OBSERVATION_LIST,
    {
      params,
    }
  );
};

// export const fetchGeneratePDF = (payload) => {
//   const { appointment_id, investigation_id } = payload;

//   let params = {
//     appointment_id,
//     investigation_id,
//     // zone_id,
//   };

//   if (appointment_id && investigation_id) {

//     return axiosInstance.put(`${EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF}/?appointment_id=${appointment_id}&investigation_id=${investigation_id}`, {
//       params,
//     });
//   }
//   return;
// };

// export const fetchGeneratePDF = (payload) => {
//   const { appointment_id, investigation_id } = payload;

//   if (appointment_id && investigation_id) {
//     return axiosInstance.put(
//       `${EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF}/?appointment_id=${appointment_id}&investigation_id=${investigation_id}`,
//       {
//         headers: {
//           'Content-Type': 'application/pdf',
//           'accept': 'application/pdf'
//         },
//       },
//       {
//         responseType: 'blob',
//       }
//     );
//   }
//   return;
// };

// export const fetchGeneratePDF = (payload) => {
//   const {
//     appointment_id,
//     investigation_id,
//     display_banner = false,
//     display_footer_banner = false,
//   } = payload;

//   console.log("display_banner", display_banner);
//   console.log("display_footer_banner", display_footer_banner);

//   if (appointment_id && investigation_id) {
//     return axiosInstance.put(
//       `${EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF}/?appointment_id=${appointment_id}&investigation_id=${investigation_id}&display_banner=${display_banner}&display_footer_banner=${display_footer_banner}`,
//       {},
//       {
//         headers: {
//           'Content-Type': 'application/pdf',
//           accept: 'application/pdf',
//         },
//         responseType: 'blob',
//       }
//     );
//   }
//   return;
// };

export const fetchGeneratePDF = async (payload) => {
  console.log("payload", payload);
  const {
    appointment_id,
    investigation_id,
    display_banner = false,
    display_footer_banner = false,
  } = payload;

  if (
    !appointment_id ||
    !Array.isArray(investigation_id) ||
    investigation_id.length === 0
  ) {
    throw new Error("Missing appointment ID or investigation IDs");
  }

  const apiUrl = EndPoints.RESULT_ENTRY_REPORT.GENERATE_PDF;

  try {
    const response = await axiosInstance.put(
      apiUrl,
      {
        appointment_id,
        investigation_ids: investigation_id,
        display_banner,
        display_footer_banner,
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/pdf",
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.log("Full error object:", error);

    if (error.response) {
      console.log("Error status:", error.response.status);
      console.log("Error headers:", error.response.headers);
      console.log("Error data type:", typeof error.response.data);
      console.log(
        "Error data instanceof Blob:",
        error.response.data instanceof Blob
      );

      // Check if response data is a blob
      if (error.response.data instanceof Blob) {
        console.log("Blob size:", error.response.data.size);
        console.log("Blob type:", error.response.data.type);

        try {
          // Use the text() method which returns a Promise
          const errorText = await error.response.data.text();
          console.log("Raw error text from blob:", errorText);

          if (errorText) {
            try {
              const errorJson = JSON.parse(errorText);
              console.log("Parsed error JSON:", errorJson);

              const errorMessage =
                errorJson.detail ||
                errorJson.message ||
                errorJson.error ||
                errorText;

              const customError = new Error(errorMessage);
              customError.originalError = error;
              customError.parsedJson = errorJson;
              customError.blobText = errorText;
              customError.responseStatus = error.response.status;
              customError.responseStatusText = error.response.statusText;
              throw customError;
            } catch (parseError) {
              console.log("JSON parse error:", parseError);

              const customError = new Error(
                errorText ||
                  `HTTP ${error.response.status}: ${error.response.statusText}`
              );
              customError.originalError = error;
              customError.parseError = parseError;
              customError.blobText = errorText;
              customError.responseStatus = error.response.status;
              customError.responseStatusText = error.response.statusText;
              throw customError;
            }
          } else {
            // Empty blob
            const customError = new Error(
              `HTTP ${error.response.status}: ${error.response.statusText} - Empty response`
            );
            customError.originalError = error;
            customError.blobText = "";
            customError.responseStatus = error.response.status;
            customError.responseStatusText = error.response.statusText;
            throw customError;
          }
        } catch (blobError) {
          console.log("Error reading blob:", blobError);

          // If blob reading fails, throw the blobError if it's already our custom error
          if (blobError.originalError) {
            throw blobError;
          }

          // Otherwise create a new error
          const customError = new Error(
            `HTTP ${error.response.status}: ${error.response.statusText} - Could not read error details`
          );
          customError.originalError = error;
          customError.blobError = blobError;
          customError.responseStatus = error.response.status;
          customError.responseStatusText = error.response.statusText;
          throw customError;
        }
      } else {
        // Non-blob error response
        console.log("Error response data:", error.response.data);
        const errorMessage =
          error.response.data?.detail ||
          error.response.data?.message ||
          error.response.data?.error ||
          `HTTP ${error.response.status}: ${error.response.statusText}`;

        const customError = new Error(errorMessage);
        customError.originalError = error;
        customError.responseStatus = error.response.status;
        customError.responseStatusText = error.response.statusText;
        throw customError;
      }
    } else if (error.request) {
      console.log("No response received:", error.request);
      const customError = new Error("No response received from server");
      customError.originalError = error;
      throw customError;
    } else {
      console.log("Error setting up request:", error.message);
      const customError = new Error(error.message);
      customError.originalError = error;
      throw customError;
    }
  }
};

// export const multipleGeneratePDF = (payload) => {
//   const {
//     appointment_data,
//     display_banner = false,
//     display_footer_banner = false,
//   } = payload;

//   if (!Array.isArray(appointment_data) || appointment_data.length === 0) {
//     return Promise.reject(
//       new Error("Invalid payload: appointment_data is missing or empty")
//     );
//   }

//   const { appointment_id, investigation_ids } = appointment_data[0];

//   if (
//     !appointment_id ||
//     !Array.isArray(investigation_ids) ||
//     investigation_ids.length === 0
//   ) {
//     return Promise.reject(
//       new Error(
//         "Invalid payload: appointment_id or investigation_ids are missing"
//       )
//     );
//   }

//   const zoneId = localStorage.getItem("zone_id");
//   const authToken = localStorage.getItem("accessToken");
//   const apiUrl = `${
//     EndPoints.RESULT_ENTRY_REPORT.MULTIPLE_GENERATE_PDF
//   }?zone_id=${zoneId || ""}`;

//   return axiosInstance.post(
//     apiUrl,
//     {
//       appointment_data,
//       display_banner,
//       display_footer_banner,
//     },
//     {
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/zip",
//         Authorization: `Bearer ${authToken}`,
//       },
//       responseType: "blob",
//     }
//   );
// };

export const multipleGeneratePDF = async (payload) => {
  console.log("payload", payload);
  const {
    appointment_data,
    display_banner = false,
    display_footer_banner = false,
  } = payload;

  if (!Array.isArray(appointment_data) || appointment_data.length === 0) {
    throw new Error("Invalid payload: appointment_data is missing or empty");
  }

  const { appointment_id, investigation_ids } = appointment_data[0];

  if (
    !appointment_id ||
    !Array.isArray(investigation_ids) ||
    investigation_ids.length === 0
  ) {
    throw new Error(
      "Invalid payload: appointment_id or investigation_ids are missing"
    );
  }

  const zoneId = localStorage.getItem("zone_id");
  const authToken = localStorage.getItem("accessToken");
  const apiUrl = `${
    EndPoints.RESULT_ENTRY_REPORT.MULTIPLE_GENERATE_PDF
  }?zone_id=${zoneId || ""}`;

  try {
    const response = await axiosInstance.post(
      apiUrl,
      {
        appointment_data,
        display_banner,
        display_footer_banner,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/zip",
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.log("Full error object:", error);

    if (error.response) {
      console.log("Error status:", error.response.status);
      console.log("Error headers:", error.response.headers);
      console.log("Error data type:", typeof error.response.data);
      console.log(
        "Error data instanceof Blob:",
        error.response.data instanceof Blob
      );

      // Check if response data is a blob
      if (error.response.data instanceof Blob) {
        console.log("Blob size:", error.response.data.size);
        console.log("Blob type:", error.response.data.type);

        try {
          // Use the text() method which returns a Promise
          const errorText = await error.response.data.text();
          console.log("Raw error text from blob:", errorText);

          if (errorText) {
            try {
              const errorJson = JSON.parse(errorText);
              console.log("Parsed error JSON:", errorJson);

              const errorMessage =
                errorJson.detail ||
                errorJson.message ||
                errorJson.error ||
                errorText;

              const customError = new Error(errorMessage);
              customError.originalError = error;
              customError.parsedJson = errorJson;
              customError.blobText = errorText;
              customError.responseStatus = error.response.status;
              customError.responseStatusText = error.response.statusText;
              throw customError;
            } catch (parseError) {
              console.log("JSON parse error:", parseError);

              const customError = new Error(
                errorText ||
                  `HTTP ${error.response.status}: ${error.response.statusText}`
              );
              customError.originalError = error;
              customError.parseError = parseError;
              customError.blobText = errorText;
              customError.responseStatus = error.response.status;
              customError.responseStatusText = error.response.statusText;
              throw customError;
            }
          } else {
            // Empty blob
            const customError = new Error(
              `HTTP ${error.response.status}: ${error.response.statusText} - Empty response`
            );
            customError.originalError = error;
            customError.blobText = "";
            customError.responseStatus = error.response.status;
            customError.responseStatusText = error.response.statusText;
            throw customError;
          }
        } catch (blobError) {
          console.log("Error reading blob:", blobError);

          // If blob reading fails, throw the blobError if it's already our custom error
          if (blobError.originalError) {
            throw blobError;
          }

          // Otherwise create a new error
          const customError = new Error(
            `HTTP ${error.response.status}: ${error.response.statusText} - Could not read error details`
          );
          customError.originalError = error;
          customError.blobError = blobError;
          customError.responseStatus = error.response.status;
          customError.responseStatusText = error.response.statusText;
          throw customError;
        }
      } else {
        // Non-blob error response
        console.log("Error response data:", error.response.data);
        const errorMessage =
          error.response.data?.detail ||
          error.response.data?.message ||
          error.response.data?.error ||
          `HTTP ${error.response.status}: ${error.response.statusText}`;

        const customError = new Error(errorMessage);
        customError.originalError = error;
        customError.responseStatus = error.response.status;
        customError.responseStatusText = error.response.statusText;
        throw customError;
      }
    } else if (error.request) {
      console.log("No response received:", error.request);
      const customError = new Error("No response received from server");
      customError.originalError = error;
      throw customError;
    } else {
      console.log("Error setting up request:", error.message);
      const customError = new Error(error.message);
      customError.originalError = error;
      throw customError;
    }
  }
};

export const createPatientLabResultEntry = (payload) => {
  return axiosInstance.put(
    EndPoints.PANNEL_WISE_BUSISSENES_REPORT.CREATEPATIENTLABRESULTENTRY,
    payload
  );
};

export const createPatientDocumentUpload = (payload) => {
  return axiosInstance.post(
    EndPoints.PANNEL_WISE_BUSISSENES_REPORT.UPLOADDOCUMENT,
    payload
  );
};

export const fetchReportRoleById = (payload) => {
  return axiosInstance.get(
    `${EndPoints.ASSIGN_ROLE.LIST_BY_ID}/${payload?.employee_code_id}`,
    { timeout: 30000 }
  );
};

export const deleteData = (payload) => {
  const url = EndPoints.DOCUMENT.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};
export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.DOCUMENT.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};

export const fetchViewPatientResultEntryData = (payload) => {
  const { appointment_id } = payload;
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let params = {
    appointment_id,
    zone_id,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(EndPoints.RESULT_ENTRY_REPORT.VIEW_PATIENT_LIST, {
    params,
  });
};

export const fetchDowloadDocument = (payload) => {
  const { appointment_id, investigation_id } = payload;

  return axiosInstance.get(
    `${EndPoints.RESULT_ENTRY_REPORT.INVESTIGATION_DOCUMENT_DOWNLOAD}/${appointment_id}/${investigation_id}`
  );
};

export const fetchResultEntryDowloadDocument = ({
  appointment_id,
  investigation_id,
}) => {
  console.log("down", { appointment_id, investigation_id });

  return axiosInstance.get(
    `${EndPoints.RESULT_ENTRY_REPORT.RESULT_ENTRY_DOWNLOAD_PATIENT_DOCUMENT_LIST}/${appointment_id}/${investigation_id}`
  );
};

export const deleteResultEntryDowloadDocument = (payload) => {
  const url =
    EndPoints.RESULT_ENTRY_REPORT.RESULT_ENTRY_DELETE_PATIENT_DOCUMENT +
    `/${payload}`;
  return axiosInstance.delete(url);
};

// export const fetchInvestigationDowloadDocument = (payload) => {
//   const { appointment_id, investigation_id } = payload;
//   console.log("fetchInvestigationDowloadDocument", payload);

//   const investigationIdPath = Array.isArray(investigation_id)
//     ? investigation_id.join(",")
//     : investigation_id;

//   const url = `${EndPoints.RESULT_ENTRY_REPORT.DOWNLOAD_INVESTIGATION_DOCUMENT_LIST}/${appointment_id}/${investigationIdPath}`;

//   return axiosInstance.get(url);
// };

export const fetchInvestigationDowloadDocument = (payload) => {
  const { appointment_id, investigation_id, token } = payload;
  console.log("fetchInvestigationDowloadDocument", payload);

  const investigationIdPath = Array.isArray(investigation_id)
    ? investigation_id.join(",")
    : investigation_id;

  const url = `${EndPoints.RESULT_ENTRY_REPORT.DOWNLOAD_INVESTIGATION_DOCUMENT_LIST}/${appointment_id}/${investigationIdPath}`;

  const config =
    token && validateToken(token)
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {};

  return axiosInstance.get(url, config);
};
